import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center flex-col items-center mt-6 text-center"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandartTemplate = _resolveComponent("StandartTemplate")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_component_StandartTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-medium text-lg" }, "Реферальная программа!", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-6 text-lg" }, " Нажмите на ссылку чтобы скопировать и отправить ее друзьям! ", -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["p-6 text-4xl w-full mt-8 border-primary text-center rounded-md transition-all duration-500", _ctx.showCopyText ? 'bg-primary' : 'bg-yellowLight']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.showCopyText ? "Скопировано" : _ctx.link), 1)
        ], 2),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (_ctx.QRCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-lg" }, [
                  _createTextVNode(" Ваш персональный реферальный "),
                  _createElementVNode("br"),
                  _createTextVNode(" QR код ")
                ], -1)),
                _createElementVNode("img", {
                  class: "w-40",
                  src: _ctx.QRCode,
                  alt: "QR code"
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_auto_animate]
        ])
      ])
    ]),
    _: 1
  }))
}